import { RootState } from '../../../../init-store/index';
import { selectIsB2BHost, selectSelectedUid } from '../config/selectors';
import { UserType } from './enums';

export const isAnonymousUser = (state: RootState): boolean => !state.user;

export const isB2bUserSelector = (state: RootState): boolean => Boolean(state.user?.isB2b);

export const isYandexSsoUserSelector = (state: RootState): boolean => Boolean(state.user?.isYandexSsoUser);

export const isYandexTeamUserSelector = (state: RootState): boolean => Boolean(state.user?.isYandexTeamUser);

export const getUserSelector = (state: RootState) => state.user;

export const selectIsUserLegalEntity = (state: RootState) => Boolean(state.user?.isLegalEntity);

export const isPDDUserSelector = (state: RootState): boolean => Boolean(state.user?.isPDD);

export const isSSOUserSelector = (state: RootState): boolean => Boolean(state.user?.isSSO);

export const selectIsUserB2BDomainMismatch = (state: RootState) => {
    const isB2BHost = selectIsB2BHost(state);
    const isB2BUser = selectIsUserLegalEntity(state);

    return isB2BHost !== isB2BUser;
};

export const selectUserUid = (state: RootState) => selectSelectedUid(state) ?? state.user?.uid;

export const selectUserTypes = (state: RootState): UserType[] => {
    const types = [];
    if (isAnonymousUser(state)) {
        types.push(UserType.ANONYM);
    }
    if (isPDDUserSelector(state)) {
        types.push(UserType.PDD_B2B);
    }

    if (isB2bUserSelector(state)) {
        types.push(UserType.CONNECTED_B2B);
    }

    if (!isPDDUserSelector(state) && !isB2bUserSelector(state) && !isAnonymousUser(state)) {
        types.push(UserType.B2C);
    }
    if (isSSOUserSelector(state)) {
        types.push(UserType.SSO);
    }
    if (isYandexTeamUserSelector(state)) {
        types.push(UserType.YANDEX_TEAM);
    }
    if (selectIsUserLegalEntity(state)) {
        types.push(UserType.LEGAL_ENTITY);
    }
    return types;
};

export const getLogoOrganization = (state: RootState) => {
    return state.user?.logoOrganization?.logo?.orig?.url;
};
export const selectEnabledNoB2cTariffPromo = (state: RootState) => state.user?.enabledNoB2cTariffPromo;

export const selectBandwidthEffective4kCodecExp = (state: RootState) =>
    state.user?.bandwidthEffective4kCodecExp ?? false;
